module.exports = __webpack_public_path__ + "img/Vector17.1712bcca.svg";